import { render, staticRenderFns } from "./CallPage.vue?vue&type=template&id=306ec2d6&scoped=true"
import script from "./CallPage.vue?vue&type=script&lang=js"
export * from "./CallPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ec2d6",
  null
  
)

export default component.exports